import DiscountIcon from '@ordr-as/icons/DiscountIcon';
import { Dispatch, SetStateAction } from 'react';
import { useLocation } from '../../../../context/LocationContext';
import { useTotalPrice, useOriginalTotalPrice } from '../../../../hooks/useTotalPrice';
import useIntl from '../../../../hooks/useIntl';
import { useCartStore } from '../../../../context/cart/CartStore';
import { useActiveDigitalBill } from '../../../../context/DigitalBillStore';

type DiscountLabelProps = {
  setOpenDiscountDialog: Dispatch<SetStateAction<boolean>>;
};

const DiscountLabel = (props: DiscountLabelProps) => {
  const { setOpenDiscountDialog } = props;
  const { appliedDiscount } = useCartStore((state) => ({
    appliedDiscount: state.appliedDiscount,
  }));

  const activeDigitalBill = useActiveDigitalBill();
  const intl = useIntl();
  const { formatCurrency } = useLocation();
  const totalPrice = useTotalPrice();
  const originalPrice = useOriginalTotalPrice();

  const discount = totalPrice - originalPrice;

  const handleClick = () => {
    setOpenDiscountDialog(true);
  };

  if (!appliedDiscount) {
    return null;
  }

  const label =
    activeDigitalBill !== undefined
      ? intl.formatMessage({ id: 'cart.discount.label.openBill' })
      : intl.formatMessage({ id: 'cart.discount.label' });

  const backgroundAndTextColoring =
    activeDigitalBill !== undefined ? 'bg-pink-lightest text-brand-black' : 'bg-green-lightest text-green-darkest';

  return (
    <div
      className={`px-4 py-3 flex justify-between ${backgroundAndTextColoring} rounded m-4 cursor-pointer`}
      onClick={handleClick}
    >
      <span className="flex items-center gap-2">
        <DiscountIcon />
        <span>{label}</span>
      </span>
      {!activeDigitalBill && <span>{formatCurrency(discount)}</span>}
    </div>
  );
};

export default DiscountLabel;
